import { render, staticRenderFns } from "./VATStatementDetails.vue?vue&type=template&id=4dfa900a"
import script from "./VATStatementDetails.vue?vue&type=script&lang=js"
export * from "./VATStatementDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports